module.exports = __webpack_public_path__ + "assets/img/whatAPP1.f585333f.svg";